<template>
  <el-dialog
    title="电子数据存证证书"
    class="com-dialog g-certi-dialog"
    :visible.sync="dialogVisible"
    :before-close="close"
    width="980px"
  >
    <div class="g-certi-dialog-conent">
      <!-- <div style="text-align: center; margin: 20px 0;">证书编号：{{ this.presId }}</div> -->
      <div class="img-certi">
        <a
          :href="certUrl"
          target="_blank"
          title="点击放大"
          v-if="certStatus"
          v-loading="certLoading"
          class="img-certi-a"
        >
          <img
            :src="certUrl"
            @loadstart="certLoading = true"
            @load="certLoading = false"
            class="img-certi-img"
          />
        </a>
        <a
          href="javascript:void(0);"
          @click="flushCertStatus()"
          title="点击刷新"
          v-else
          v-loading="certLoading"
          style="min-height: 637px; display: inline-block"
        >
          <img
            :src="certUrl"
            @loadstart="certLoading = true"
            @load="certLoading = false"
          />
        </a>
      </div>
      <div class="right-btn-warp">
        <el-button
          id="tag-copy"
          :data-clipboard-text="leftPad(param.presId, 10, '0')"
          @click="copyText($event)"
          size="small"
          class="g-certi-btn"
          >复制备案号
        </el-button>
        <el-button
          id="tag-copy1"
          :data-clipboard-text="param.presId"
          @click="copyTextToQuery($event)"
          size="small"
          class="g-certi-btn"
          >复制备案号并查询
        </el-button>
        <el-button @click="downloadCert(1)" size="small" class="g-certi-btn"
          >下载图片证书</el-button
        >
        <el-button @click="downloadCert(2)" size="small" class="g-certi-btn"
          >下载PDF证书</el-button
        >
        <div style="display: flex; position: relative">
          <el-button
            size="small"
            class="g-certi-btn"
            v-if="showInput"
            @click="queryIdentification(param.presId)"
            >获取工信部标识</el-button
          >
          <el-input
            id="text"
            @click="copy"
            size="medium"
            v-model="gxbbs"
            v-else
            readonly
          >
            <i
              class="el-icon-copy-document"
              style="line-height: 36px"
              slot="suffix"
              @click="copy"
            />
          </el-input>
          <el-tooltip effect="light" placement="bottom-end">
            <div slot="content">
              数据同步需要一定时间，<br />可在生成数据后次日查询
            </div>
            <i
              class="el-icon-question"
              style="
                font-size: 16px;
                margin-left: 10px;
                color: #a1a1a1;
                cursor: pointer;
                position: absolute;
                margin-left: 100%;
              "
            ></i>
          </el-tooltip>
          <a
            href="https://dms.citln.cn/"
            target="_blank"
            style="
              font-size: 14px;
              color: #5091d6;
              cursor: pointer;
              position: absolute;
              margin-top: 10%;
              margin-left: 100%;
              width: 50px;
            "
            >前往 ></a
          >
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="mini" type="primary" @click="close">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { ApiMethods, configUrl } from "@/assets/js/http-serve/http-methods";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import GlobalConfig from "@/assets/js/config/global";
import Clipboard from "clipboard";
import leftTab from "../judicialService/leftTab";
import { isInDingTalk } from '@/assets/js/utils/ding-env';

export default {
  props: {
    param: {
      type: Object
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    listType: {
      type: String,
      default: "seniorList"
    }
  },
  data () {
    return {
      certLoading: true,
      certStatus: false,
      certUrl: null,
      gxbbs: "",
      showInput: true
    };
  },
  created () {
    this.initCerti();
  },
  methods: {
    //获取工信部标识
    queryIdentification (presId) {
      console.log(presId);
      this.showInput = false;
      ApiMethods.ApplySignController.humi({ presId: presId })
        .then(res => {
          console.log(res);
          if (res.success) {
            this.gxbbs = res.data ? res.data : "暂未获取到工信部标识";
          } else {
            this.$message.error("获取工信部标识失败");
          }
        })
        .catch(err => { });
    },
    copy () {
      let text = document.getElementById("text");
      text.select();
      document.execCommand("Copy");
    },
    async initCerti () {
      let _this = this;
      let _param = _this.param;
      this.certUrl = ApiMethods.CertiController.showCerti_url(_param);
      ApiMethods.CertiController.certiStatus(_param).then(result => {
        this.certStatus = result.success && result.data;
      });
    },
    downloadCert: function (type) {
      let _this = this;
      let _param = _this.param;
      _param.downType = type;
      console.log(_param);
      window.location.href = ApiMethods.CertiController.downCerti_url(_param);
    },
    flushCertStatus: function () {
      let _param = this.param;
      ApiMethods.CertiController.certiStatus(_param).then(result => {
        this.certStatus = result.success && result.data;
        if (result.success && !result.data) {
          this.$confirm("证书努力生成中，请稍候再试", "提示", {
            confirmButtonText: "确定",
            type: "warning",
            showCancelButton: false
          })
            .then(() => { })
            .catch(() => { });
        } else if (result.success && result.data) {
          // location.reload();
        }
      });
    },
    // 复制
    copyText () {
      const clipboard = new Clipboard("#tag-copy");

      clipboard.on("success", e => {
        this.$message({
          type: "success",
          message: "复制成功"
        });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // 不支持复制
        this.$message({
          type: "waning",
          message: "该浏览器不支持自动复制"
        });
        // 释放内存
        clipboard.destroy();
      });
    },
    // 复制
    copyTextToQuery () {
      const clipboard = new Clipboard("#tag-copy1");
      clipboard.on("success", e => {
        this.$message({
          type: "success",
          message: "复制成功"
        });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // 不支持复制
        this.$message({
          type: "waning",
          message: "该浏览器不支持自动复制"
        });
        // 释放内存
        clipboard.destroy();
      });
      setTimeout(() => {
        var newWindow = '';
        if (!isInDingTalk) newWindow = window.open();
        let presId = this.leftPad(this.param.presId, 10, "0");
        let href =
          `${GlobalConfig.domain.junziqianWebOp}/blockChain?presId=` + presId;
        isInDingTalk ? location.href = href : newWindow.location.href = href
      }, 1000);
    },
    close () {
      this.$emit("setCSDialogData", {
        cSDialogVisible: false,
        cSDialogData: {}
      });
    },
    leftPad (value, size, str) {
      // {{ v.num|leftPad(10, '0')}}
      if (value == null || value === undefined) {
        return value;
      }
      var result = "" + value;
      if (size <= result.length) {
        return result;
      }
      var pad = typeof str === "string" && str.length === 1 ? str : "0";
      for (var idx = result.length; idx < size; idx++) {
        result = pad + result;
      }
      return result;
    }
  }
};
</script>

<style lang="less">
.el-icon-copy-document:hover {
  color: #00abea;
  cursor: pointer;
}
.g-certi-dialog .el-dialog__footer {
  -webkit-box-shadow: 0 3px 10px rgba(0, 0, 0, 0.17);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.17);
  padding: 10px 15px;
}

.g-certi-dialog-conent {
  box-sizing: border-box;
  width: 100%;
  padding: 10px 80px 15px 205px;
  display: flex;

  .img-certi {
    box-sizing: border-box;
    min-height: 636px;
    flex: 1;
    padding-right: 40px;
  }

  .img-certi-img,
  .img-certi-a {
    width: 100%;
    height: auto;
  }

  .right-btn-warp {
    flex: 0 0 175px;
    padding-top: 26px;
  }

  .g-certi-btn {
    width: 100%;
    height: 35px;
    display: block;
    margin-bottom: 15px;
    margin-left: 0;

    &:hover {
      background-color: #fff;
      color: rgba(236, 28, 28, 1);
      border-color: rgba(236, 28, 28, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/apply-list/certiServiceDialog.vue